import React from "react";
import { message } from "antd";
import PaginationBase from "../../../common/base/PaginationBase";
import { PAGINATION, FILTER } from "../../../common/types/paginationType";
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import global from "../../../common/utility/global";
import dialog from '../../../common/utility/dialog';
import auth from '../../../common/utility/auth';

import tipoCambioDiarioService from "../../../service/administracion/tipoCambioDiarioService";
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import establecimientoService from "../../../service/administracion/establecimientoService";
import centroCostoService from "../../../service/tesoreria/centroCostoService";
import fondoFijoService from "../../../service/tesoreria/fondoFijoService";
import fondoFijoEstadoService from "../../../service/tesoreria/fondoFijoEstadoService";
import empleadoService from "../../../service/administracion/empleadoService";
import padronReducidoService from '../../../service/integracion/padronReducidoService';

import Header from "../../../components/Header";
import Filters from './Filters';
import FormModal from './FormModal';
import ResultList from './ResultList';
import FormModalVer from '../FondoFijo/FormModalVer';
import monedaService from "../../../service/administracion/monedaService";
import planCuentaService from "../../../service/administracion/planCuentaService";
import FondoFijoDetalle from './FondoFijoDetalleModal';


export default class Index extends PaginationBase {
	constructor(props) {
		super(props);
		this.props.onSetBreadcrumb();
		this.state = {
			loadingSource: true,
			tiposCambioDiario: [],
			estadosFondoFijo: [],
			establecimientos: [],
			centrosCosto: [],
			monedas: [],
			cuentasContable: [],
			centrosCostoLoading: false,
			filter: {
				fechaInicioStr: global.fetchCurrentDateStr(true),
				fechaFinStr: global.fetchCurrentDateStr(),
				nobreEmpleado: "",
				idEstablecimiento: 0,
				idEmpleado: 0,
				idCentroCosto: 0,
				idEstadoFondoFijo: 0,
				estadosFondoFijo: [],
				establecimientos: [],
				centrosCosto: [],
				...FILTER,
			},
			pagination: PAGINATION,
			visible: false,
			visibleVer: false,
			visibleDetail: false,
			visibleNewDetalle: false,
			formValues: this.fetchEmptyFormValues(),
			formValuesDetalle: this.fetchEmptyFormValuesDetalle(),
		};
	}

	fetchMinCurrentDateStr(firstDayOfTheMonth) {
		var date = new Date();
		var yyyy = date.getFullYear();
		var mm = String(date.getMonth() + 1).padStart(2, '0');
		var dd = firstDayOfTheMonth === true ? '01' : String(date.getDate()).padStart(2, '0');
		return yyyy + '/' + mm + '/' + dd;
	};

	fetchEmptyFormValues = () => {
		return {
			id: 0,
			idEstablecimiento: 0,
			idEmpleado: 0,
			idCentroCosto: 0,
			serie: "OF01",
			documento: "",
			fechaStr: global.fetchCurrentDateStr(),
			fechaVencimientoStr: global.fetchCurrentDateStr(),
			minFechaStr: this.fetchMinCurrentDateStr(),
			diasVencimiento: 0,
			tipoCambio: 0,
			saldoInicialSoles: 0,
			saldoCierreSoles: 0,
			saldoInicialDolares: 0,
			saldoCierreDolares: 0,
			observacion: "",
			montoSoles: [],
			montoDolares: [],
			establecimientos: [],
			centrosCosto: [],
			empleados: [],

			documentoEmpleado: "",

			empleadoLoading: false,
			centroCostoLoading: false,
			activeKey: "1",
		};
	};

	fetchEditFormValues = (value) => {
		console.log(value);
		debugger
		return {
			id: value.id,
			idEmpleado: value.idEmpleado,
			idEstablecimiento: value.idEstablecimiento,
			serie: value.serie,
			documento: value.documento,
			documentoEmpleado: value.documentoEmpleado,
			fechaStr: value.fechaStr,
			fechaVencimientoStr: value.fechaVencimientoStr,
			diasVencimiento: value.diasVencimiento,
			tipoCambio: value.tipoCambio,
			observacion: value.observacion,
			saldoInicialSoles: value.saldoInicialSoles,
			saldoCierreSoles: value.saldoCierreSoles,
			saldoInicialDolares: value.saldoInicialDolares,
			saldoCierreDolares: value.saldoCierreDolares,
			idCentroCosto: value.idCentroCosto,

			empleadoLoading: false,
			activeKey: "1",

			listaFondoFijoDetalle: this.fetchEditFormValuesDetalle,
			establecimientos: [],
			empleados: [],

			centrosCosto: [],

			nombreCentroCosto: value.nombreCentroCosto,
			empleado: value.empleado,
			nombreEstablecimientoSucursal: value.nombreEstablecimientoSucursal
		}
	}

	fetchEmptyFormValuesDetalle = () => {
		return {
			id: 0,
			monto: 0,
			cuentasContable: [],
			empleados: [],
			monedas: [],
			listaFondoFijoDetalle: [],
			descripcion: ""
		};
	};

	handleClearFilters = () => {
		var filter = {
			serieDocumento: '',
			responsable: '',
			idCentroCosto: 0,
			idEstablecimiento: 0,
			idEstadoFondoFijo: 0,
			fechaInicioStr: global.fetchCurrentDateStr(true),
			fechaFinStr: global.fetchCurrentDateStr(),
			...FILTER
		};
		this.setState({ filter: filter });
		this._handlePagination(filter);
	};

	handleKeyUpInput = (e) => {
		e.preventDefault();
		if (e.keyCode === 13) {
			const filter = { ...this.state.filter, ...FILTER };
			this._handlePagination(filter);
		}
	};

	handleOnChangeEmpleado = async (value) => {
		console.log(value);
		debugger
		var numDoc = value.label.split('-')[value.label.split('-').length - 1];
		console.log(value.label);

		this.setState({
			formValues: {
				...this.state.formValues,
				documentoEmpleado: numDoc
			}
		});

	}

	handleBuscarEmpleado = async (value, form) => {

		this.setState({
			formValues: { ...this.state.formValues, empleadoLoading: true },
		});

		const response = await padronReducidoService.tesoreria_empleado(value);

		if (response.status === 200) {
			this.setState(
				{
					formValues: {
						...this.state.formValues,
						empleadoLoading: false,
						direcciones: response.data.direcciones,
					},
				},
				() => {
					form.setFieldsValue({
						empleados: response.data.empleados,
						idEmpleado: response.data.empleados.length > 0 ? { key: response.data.empleados[0].id } : undefined,
						idEstablecimientoEmpleado: response.data.direcciones.length > 0 ? { key: response.data.direcciones[0].id } : undefined,
						direccionEmpleado: response.data.direcciones.length > 0 ? response.data.direcciones[0].direccion : ""
					});
				}
			);
		} else {
			this.setState(
				{
					formValues: {
						...this.state.formValues,
						clienteLoading: false,
						direcciones: [],
					},
				}
			);
		}
	};

	handleChange = async (property, value) => {
		const filter = { ...this.state.filter, [property]: value };
		this.setState({ filter });

		if (property === "idEstablecimiento") {
			this.setState({ centrosCostoLoading: true });
			const centrosCosto = await centroCostoService.listarPorIdEstablecimiento(value);
			this.setState({
				filter: { ...this.state.filter, idCentroCosto: undefined },
				centrosCosto: centrosCosto ? centrosCosto : [],
				centrosCostoLoading: false
			});
		}
	};


	handleNew = async () => {
		
		var idSoles = SOLES;
		var formValues = this.fetchEmptyFormValues();
		formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
		formValues.establecimientos = this.state.establecimientos;
		formValues.centrosCosto = this.state.centrosCosto;
		formValues.empleados = this.state.empleados;
		formValues.monedas = this.state.monedas;

		const datosInicialesFilter = {
			idUsuario: auth.user().id
		}
		const datosIniciales = await fondoFijoService.datosIniciales(datosInicialesFilter);

		if (datosIniciales !== undefined) {
		}

		if (formValues.idEstablecimiento > 0) {
			const centrosCosto = await await centroCostoService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
			formValues.centrosCosto = centrosCosto ? centrosCosto : [];
		}

		this.setState({
			visible: true,
			formValues
		});
	};

	fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
		const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
		if (filter.length > 0)
			return parseFloat(filter[0].venta).toFixed(3);
		else
			return '0.000';
	}

	handleChangeForm = async (property, value, form) => {

		if (property === "idEmpleado") {
			const direcciones = await establecimientoService.listarPorIdEntidad(value);
			
			this.setState({
				formValues: {
					...this.state.formValues,

				}
			}, () => {
				form.setFieldsValue({
					idEstablecimientoEmpleado: { key: direcciones.length > 0 ? direcciones[0].id : undefined }
				});
			});
		}

		if (property === "idEstablecimiento") {
			
			this.setState({ formValues: { ...this.state.formValues, centroCostoLoading: true } });
			const centrosCosto = await centroCostoService.listarPorIdEstablecimiento(value);
			this.setState({
				formValues: {
					...this.state.formValues,
					centroCostoLoading: false,
					centrosCosto: centrosCosto ? centrosCosto : []
				}
			});
		}

		if (property === "fechaStr") {

			console.log('cambio 1')
			var arrayD1 = value.split('/');

			const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

			this.setState({
				formValues: {
					...this.state.formValues,
					tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),

					fechaStr: value,

				}
			});
		}

		if (property === "fechaVencimientoStr") {
			const dias_vencimiento = this.CalcularDiasVencimiento(this.state.formValues.fechaStr, value);

			this.setState({
				formValues: {
					...this.state.formValues,
					diasVencimiento: dias_vencimiento,
					fechaVencimientoStr: value
				}
			});
		}

		if (property === "diasVencimiento") {
			var arrayD1 = this.state.formValues.fechaStr.split('/');
			var date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
			var fechaVencimiento = date1.setDate(date1.getDate() + parseInt(value));

			let day = date1.getDate()
			let month = date1.getMonth() + 1
			let year = date1.getFullYear()

			var fechaVencStr = '';

			if (month < 10) {
				fechaVencStr = `${day}/0${month}/${year}`;
			} else {
				fechaVencStr = `${day}/${month}/${year}`;
			}

			this.setState({
				formValues: {
					...this.state.formValues,
					fechaVencimientoStr: fechaVencStr
				}
			});
		}

		// if (property === "idMoneda") {

		// 	if (idMoneda === SOLES) {

		// 		const monto = this.state.monto.filter(m => m.idMoneda === value);
		// 	  } else  {
		// 		idMoneda = DOLARES_AMERICANOS ;
		// 	  }

		// 	this.setState({
		// 		formValues: {
		// 			...this.state.formValuesDetalle
		// 		}
		// 	});
		// }

	};

	handleChangeDetail = async (property, value) => {

		if (property === "idPlanCuenta") {
			this.setState({ formValues: { ...this.state.formValues, cuentaContableLoading: true } });
			const cuentasContable = await planCuentaService.listarCuentaContable(value);
			
			this.setState({
				formValues: {
					...this.state.formValues,
					cuentaContableLoading: false,
					cuentasContable: cuentasContable ? cuentasContable : []
				}
			});
		}
	}

	handleChangeTab = (key) => {
		this.setState({
			formValues: {
				...this.state.formValues,
				activeKey: key
			}
		});
	};

	CalcularDiasVencimiento = (fecha_1, fecha_2) => {
		var arrayD1 = fecha_1.split('/');
		var arrayD2 = fecha_2.split('/');

		var date1 = new Date(arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0]);
		var dateFV = new Date(arrayD2[2] + "/" + arrayD2[1] + "/" + arrayD2[0]);

		var Difference_In_Time = dateFV.getTime() - date1.getTime();
		var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

		return Difference_In_Days;
	}

	handleSave = async (values, form) => {
		
		dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
			debugger

			var response;
			if (values.id === 0 || values.id === undefined)
				response = await fondoFijoService.registrar(values);
			else
				response = await fondoFijoService.modificar(values);

			if (response.status === 200) {

				this.setState({ visible: false });
				form.setFieldsValue();
				form.resetFields();

				if (values.id === 0)
					message.success('Registrado correctamente.');
				else
					message.success('Modificado correctamente.');

				this._handlePagination(this.state.filter);
				return;
			}

			if (response.status === 400) {
				dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
				return;
			}

			dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
		});
	};

	handleSaveDetalle = (values, form) => {

		dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
			
			var response = await fondoFijoService.registrarDetalle(values);

			if (response.status === 400) {
				dialog.warning(
					<ul>
						{response.data.messages.map((item) => (
							<li>{item}</li>
						))}
					</ul>
				);
				return;
			}

			dialog.error(
				"Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
			);
		});
	};

	handleEdit = async (values) => {
		const response = await fondoFijoService.obtenerPorId(values.id);
		if (response !== undefined) {
			debugger
			var formValues = this.fetchEditFormValues(response);
			formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
			formValues.establecimientos = this.state.establecimientos;
			formValues.centrosCosto = await centroCostoService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
			formValues.empleados = this.state.empleados;

			this.setState({
				visible: true,
				formValues

			});
		}
	}

	handleDetail = async () => {
		
		var formValuesDetalle = this.fetchEmptyFormValuesDetalle();
		formValuesDetalle.empleados = this.state.empleados;
		formValuesDetalle.monedas = this.state.monedas;
		formValuesDetalle.cuentasContable = this.state.cuentasContable;

		this.setState({
			visibleDetail: true,
			formValuesDetalle,
		});
	}

	// hanldeNewDetalle = () => {
	// 	var formValuesNewDetalle = this.fetchEmptyFormValuesDetalle();

	// 	this.setState({
	// 		visibleNewDetalle: true,
	// 		formValuesNewDetalle
	// 	});
	// };

	handleVer = async (values) => {
		
		const response = await fondoFijoService.obtenerPorId(values.id);
		if (response !== undefined) {
			var formValues = this.fetchEditFormValues(response);

			this.setState({
				visibleVer: true,
				formValues
			});
		}
	}

	handleAnular = async (values) => {
		dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
			debugger
			var data = {
				idFondoFijo: values.id,
				codFondoFijoEstado: 'AN'

			};
			var response = await fondoFijoService.actualizarEstado(data);

			if (response.status === 200) {
				var empty = this.fetchEmptyFormValues();
				this.setState({ visible: false, formValues: empty });

				message.success('Registrado anulado correctamente.');

				this._handlePagination(this.state.filter);
				return;
			}

			if (response.status === 400) {
				dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
				return;
			}

			dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
		});
	}

	handleExportExcel = async () => {
		this.setState({ loadingPdf: true });
		var response = await fondoFijoService.excel(this.state.filter);
		this.setState({ loadingPdf: false });
		if (response !== undefined)
			global.dowloadFile(response.data, "Reporte de Fondo Fijo.xlsx");
	}

	handleExportPdf = async () => {
		this.setState({ loadingPdf: true });
		var response = await fondoFijoService.pdf(this.state.filter);
		this.setState({ loadingPdf: false });
		if (response !== undefined)
			global.dowloadFile(response.data, "Reporte de Fondo Fijo.pdf");
	}

	handlePrint = async () => {
		this.setState({ loadingPrint: true });
		var response = await fondoFijoService.pdf(this.state.filter);
		this.setState({ loadingPrint: false });
		if (response !== undefined) {
			var file = window.URL.createObjectURL(response.data);
			var win = window.open(file, '_blank');
			win.focus();
		}
	}

	handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
		
		this.setState({
			onSetFieldsValue,
			onGetFieldValue
		}, () => {
			
			var listaFondoFijoDetalle = this.state.formValuesDetalle.listaFondoFijoDetalle;

			listaFondoFijoDetalle.push({
				identifier: global.fetchUniqueCode(),
				fechaEntrega: global.fetchCurrentDateStr(),
				idEmpleado: 0,
				monto: 0
			});

			this.setState({
				formValuesDetalle: {
					...this.state.formValuesDetalle,
					listaFondoFijoDetalle: listaFondoFijoDetalle
				}
			});
		});
	};

	hanldeEliminarDetalle = (item) => {
		var listaFondoFijoDetalle = this.state.formValuesDetalle.listaFondoFijoDetalle.filter(m => m.identifier !== item.identifier);
		this.setState({
			formValuesDetalle: {
				...this.state.formValuesDetalle,
				listaFondoFijoDetalle: listaFondoFijoDetalle
			}
		});
	}


	async componentDidMount() {

		this._initPagination(this.state.filter, fondoFijoService.paginacion);

		const establecimientos = await establecimientoService.principales();
		const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
		const empleados = await empleadoService.listar();
		const centrosCosto = await centroCostoService.listar();
		const estadosFondoFijo = await fondoFijoEstadoService.listarEstado();
		const monedas = await monedaService.listar();
		const cuentasContable = await planCuentaService.listarCuentaContable();

		this.setState({
			loadingSource: false,
			estadosFondoFijo: estadosFondoFijo ? estadosFondoFijo : [],
			tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
			establecimientos: establecimientos ? establecimientos : [],
			centrosCosto: centrosCosto ? centrosCosto : [],
			empleados: empleados ? empleados : [],
			monedas: monedas ? monedas : [],
			cuentasContable: cuentasContable ? cuentasContable : [],
			filter: {
				...this.state.filter,
				idEstadoFondoFijo: 0,
				idEstablecimiento: 0,
				idCentroCosto: 0,

			},
		});
	}

	render() {
		return (
			<div>
				<Header
					title="Fondo Fijo"
					onNew={this.handleNew}
					loadingNew={this.state.loadingSource}
					onSearch={() => this._handlePagination(this.state.filter)}
					onClearFilters={this.handleClearFilters}
				/>
				<Filters
					estadosFondoFijo={this.state.estadosFondoFijo}
					establecimientos={this.state.establecimientos}
					centrosCostoLoading={this.state.centrosCostoLoading}
					centrosCosto={this.state.centrosCosto}
					filter={this.state.filter}
					onKeyUpSearch={this.handleKeyUpInput}
					onChange={this.handleChange}
				/>
				<ResultList
					pagination={this.state.pagination}
					loadingEdit={this.state.loadingSource}
					onExportExcel={this.handleExportExcel}
					onExportPdf={this.handleExportPdf}
					onPrint={this.handlePrint}
					onVer={this.handleVer}
					onEdit={this.handleEdit}
					onAnular={this.handleAnular}
					onDetail={this.handleDetail}
					onDeleteActive={this.handleDeleteActive}
					onChange={this._handleChangePagination}
				/>
				<FormModal
					visible={this.state.visible}
					formValues={this.state.formValues}
					onBuscarEmpleado={this.handleBuscarEmpleado}
					onChangeEmpleado={this.handleOnChangeEmpleado}
					onChange={this.handleChangeForm}
					onBlur={this.handleChangeForm}
					onClose={() => this.setState({ visible: false })}
					onSave={this.handleSave}
				/>
				<FormModalVer
					visible={this.state.visibleVer}
					formValues={this.state.formValues}
					onChangeTab={this.handleChangeTab}
					onClose={() => this.setState({ visibleVer: false })}
				/>
				<FondoFijoDetalle
					onAgregarDetalle={this.handleAgregarDetalle}
					visible={this.state.visibleDetail}
					onSave={this.handleSaveDetalle}
					onEliminarDetalle={this.hanldeEliminarDetalle}
					formValues={this.state.formValuesDetalle}
					onClose={() => this.setState({ visibleDetail: false })}
				/>
			</div>
		);
	}
}
